/** So khớp mã (Sọt / chủ vườn…) không phân biệt hoa/thường, bỏ gạch/khoảng trắng. */
export function chuanHoaMaTimKiem(s) {
  return String(s ?? "")
    .trim()
    .toUpperCase()
    .replace(/[-_\s./]/g, "");
}
